import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ExpandedViewItem } from '../../../../report-data/models/sub-models/expanded-view-item.model';
import { CurrencyPipe } from '@angular/common';
import { TrackingScreenNamesEnum } from '../../../../tracking/tracking.data';
import { HomeDataDispatcher } from '../../../../home-data';
import { ReportExpandedViewTypesEnum } from '../../../../report-data/report-data.data';

@Component({
  selector: 'app-insights-summary-card-item',
  templateUrl: './insights-summary-card-item.component.html',
  styleUrls: ['./insights-summary-card-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [CurrencyPipe],
})
export class InsightsSummaryCardItemComponent {
  @Input() item: ExpandedViewItem;
  @Input() currencyCode: string;
  @Input() locale: string;
  @Input() reportType: ReportExpandedViewTypesEnum;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  constructor(private _homeDataDispatcher: HomeDataDispatcher) {}

  handleDeeplink(deeplink: string) {
    if (!deeplink) {
      return false;
    }

    this._homeDataDispatcher.handleInsightsHubDeeplink(
      deeplink,
      this.reportType,
      this.trackingScreenName
    );
  }
}
